<template>
  <div
    class="card"
    :class="[color && `${color}-color`]"
  >
    <div class="row no-gutters align-items-center">
      <div :class="['col', flip && 'order-1']">
        <img
          :src="require(`@/assets/statistics/${image}`)"
          class="card-img img-fluid"
        >
      </div>
      <div class="col">
        <div class="card-body">
          <HighlightedText
            tag="h4"
            class="smaller text-uppercase text-white"
            :text="$tc(text, value, [`*${value}*`])"
          >
            <animated-integer
              :value="value"
              :decimals="decimals"
              class="display-2 my-1 statistic-text-color"
              tag="div"
            />
          </HighlightedText>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HighlightedText from '@/components/HighlightedText.vue'

export default {
  name: 'StatisticsCard',
  components: {
    HighlightedText
  },
  props: {
    text: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    decimals: {
      type: [Number],
      default: 0
    },
    flip: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style scoped>
.info-color{
  background-color:#575F92;
}
.light-color{
  background-color:#575F92;
}
.statistic-text-color{
  color: #F7E332;
}
</style>
